import React from "react";
import AdminUserComponent from "../../components/administracionUsuarios/adminUser";
import NavBar from "../../components/navbar/navbar";

export default function AdminUser() {
    return (
        <>
            <NavBar />
            <AdminUserComponent />
        </>
    );
}



{/*
    
    export default function AdminUser() {
    const navigate = useNavigate();
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        const validateToken = async () => {
            const currentToken = localStorage.getItem("jwt");
            if (!currentToken) {
                navigate("/");
                return;
            }
            const isValid = await verify(currentToken);
            if (!isValid) {
                navigate("/");
                return;
            }
            setAuthorized(true);
        };
        validateToken();
    }, [navigate]);

    if (!authorized) {
        return null;
    }

    return <AdminUserComponent />;
}
    */}